import { Outlet, createRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { Route as rootRoute } from '../__root'
import Layout from '@/components/layout/Layout'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authenticated',
  component: () => (
    <ProtectedRoute>
      <Layout>
        <Outlet />
      </Layout>
    </ProtectedRoute>
  ),
})
